/**
 * Wat een fan over ALLE modellen heeft uitgegeven (19-10-2026, Jordy).
 *
 * De server telt per fan-identiteit (zelfde handle / F2F-chat-id, plus de F2F-
 * weergavenamen die AL via fan_identity_links gekoppeld zijn) over alle modellen:
 * `fan_total_spend_all_models`, met per model `fan_spend_by_model`. Hier wordt
 * niets bijgeteld of afgerond; alleen samengevoegd voor de weergave.
 */
export interface SpendRij {
  fan_total_spend?: number | null
  fan_total_spend_all_models?: number | null
  fan_spend_by_model?: { model_slug: string | null; stage_name: string; amount: number; is_current?: boolean }[] | null
  fan_model_chats?: { conversation_id: number; model_slug: string; model_name: string }[] | null
  model_slug?: string | null
}

/** Over alle modellen; nooit minder dan dit model (dat telt er altijd in mee). */
export function alleModellen(c: SpendRij | null | undefined): number {
  const hier = Number(c?.fan_total_spend || 0)
  const alles = Number(c?.fan_total_spend_all_models || 0)
  return Math.max(hier, alles)
}

/** Spender = heeft bij welk model dan ook betaald. */
export function isSpender(c: SpendRij | null | undefined): boolean {
  return alleModellen(c) > 0
}

export interface ModelBedrag { naam: string; bedrag: number; hier: boolean }

/**
 * Per model: eerst dit model, dan de rest van hoog naar laag. 19-10-2026 (Jordy):
 * ALLEEN modellen waar de fan echt iets uitgaf (> €0); geen €0-regels. Leeg = geen
 * uitsplitsing. "Other models" = modellen die deze gebruiker niet ziet.
 */
export function perModel(c: SpendRij | null | undefined): ModelBedrag[] {
  const uit: ModelBedrag[] = []
  for (const r of c?.fan_spend_by_model ?? []) {
    const slug = r.model_slug ?? ''
    uit.push({ naam: r.stage_name || slug || 'Other models', bedrag: Number(r.amount || 0),
               hier: !!r.is_current || (!!slug && slug === c?.model_slug) })
  }
  return uit.filter((m) => m.bedrag > 0).sort((a, b) => Number(b.hier) - Number(a.hier) || b.bedrag - a.bedrag)
}
